import { jsx as _jsx } from "react/jsx-runtime";
import { datadogRum } from "@datadog/browser-rum";
import { useEffect } from "react";
import { default as SignPost } from "../../../assets/404.svg";
import { LandingFeatureErrorPage } from "../../error-page/landing-feature-error-page";
const CustomError = ({ statusCode , error  })=>{
    useEffect(()=>{
        if (process.env["STAGE_NAME"] !== "local") {
            datadogRum.addError(new Error(`An error of statusCode ${statusCode}`), {
                route: window.location.pathname,
                errorInformation: error
            });
        } else {
            console.log({
                error,
                statusCode
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ _jsx(LandingFeatureErrorPage, {
        title: `${statusCode} - Oops! Something went wrong`,
        subTitle: "Don’t worry, we can put you back on track!",
        image: SignPost,
        hasCta: true,
        ctaText: "Take me home",
        ctaHref: "/"
    });
};
CustomError.getInitialProps = ({ res , req , err , query , pathname  })=>{
    var ref;
    const statusCode = res ? res.statusCode : err ? err.message : 404;
    const errorLogs = {
        url: req === null || req === void 0 ? void 0 : req.url,
        pathname,
        query,
        cookies: req === null || req === void 0 ? void 0 : (ref = req.headers) === null || ref === void 0 ? void 0 : ref.cookies,
        headers: req === null || req === void 0 ? void 0 : req.headers
    };
    const error = err ? err : errorLogs;
    return {
        statusCode,
        error
    };
};
export default CustomError;
